import React, { Component } from 'react'

import { Modal } from 'react-bootstrap'
import Button from 'react-bootstrap-button-loader'

export default class WelcomeVideo extends Component<any> {
  state = {
    loading: false,
    show: true,
    id: undefined
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.props.open)
      this.setState({ 
          loading: false, 
          show: true,
          id: nextProps.open.val
     })
  }

  onModalConfirm = () => {
    this.setState({ loading: true })
    this.props.callback(this.state.id).then(isSuccess => {
      isSuccess ? this.setState({ show: false }) : this.setState({ loading: false })
    })
  }

  render() {

    return (
      <Modal show={this.state.show && this.props.open.show}>
        <Modal.Header>
          <Modal.Title>Warning</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {'Are you sure you want to set welcome video this item ?'}
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="success"
            loading={this.state.loading}
            onClick={this.onModalConfirm}
            disabled={false}>
            {this.state.loading ? 'Please wait' : "Confirm"}
          </Button>
          <Button bsStyle="default" onClick={() => this.props.callback()}>Cancel</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}